import { BadgeProps } from '@zoopla-eng/zds-components/badges';
import {
    BathroomMedium,
    BedroomMedium,
    DimensionsMedium,
    LivingRoomMedium
} from '@zoopla-eng/zds-components/icons';

type GetAttributeBadgesInput = {
    floorArea?: number | null;
    floorAreaUnitLabel?: string | null;
    floorAreaLabel?: string | null;
    numBaths?: number | null;
    numReceptions?: number | null;
    numBeds?: number | null;
    withText?: boolean;
};

export const getAttributeBadgeProps = ({
    floorArea,
    floorAreaUnitLabel,
    floorAreaLabel,
    numBaths,
    numReceptions,
    numBeds,
    withText = true
}: GetAttributeBadgesInput): Array<BadgeProps> => {
    const attributeBadgeProps: Array<BadgeProps> = [];

    if (numBeds) {
        const bedBadgeProps: BadgeProps = {
            isAnAttribute: true,
            value: numBeds,
            icon: <BedroomMedium />
        };
        if (withText) {
            bedBadgeProps.text = numBeds === 1 ? 'bed' : 'beds';
        }
        attributeBadgeProps.push(bedBadgeProps);
    }

    if (numBaths) {
        const bathBadgeProps: BadgeProps = {
            isAnAttribute: true,
            value: numBaths,
            icon: <BathroomMedium />
        };
        if (withText) {
            bathBadgeProps.text = numBaths === 1 ? 'bath' : 'baths';
        }
        attributeBadgeProps.push(bathBadgeProps);
    }

    if (numReceptions) {
        const receptionBadgeProps: BadgeProps = {
            isAnAttribute: true,
            value: numReceptions,
            icon: <LivingRoomMedium />
        };
        if (withText) {
            receptionBadgeProps.text =
                numReceptions === 1 ? 'reception' : 'receptions';
        }
        attributeBadgeProps.push(receptionBadgeProps);
    }

    if (floorArea) {
        const floorAreaBadgeProps: BadgeProps = {
            isAnAttribute: true,
            value: floorArea,
            icon: <DimensionsMedium />
        };
        if (withText && floorAreaUnitLabel) {
            floorAreaBadgeProps.text = floorAreaUnitLabel;
        }
        attributeBadgeProps.push(floorAreaBadgeProps);
    } else if (floorAreaLabel) {
        // if there's no value here we assume it's a range and use the label rather than value and unit label
        const floorAreaBadgeProps: BadgeProps = {
            isAnAttribute: true,
            range: floorAreaLabel,
            icon: <DimensionsMedium />
        };
        attributeBadgeProps.push(floorAreaBadgeProps);
    }

    return attributeBadgeProps;
};
